// shared/utils/address.utils.js
import PersonService from "shared/services/Person.service";

/**
 * Looks up zip codes for a city/state using PersonService.
 * @param {string} city
 * @param {string} state
 * @returns {Promise<string|null>} Resolves to first matching zip code or null on error.
 */
export async function lookupZipByCityState(city, state) {
  try {
    const response = await PersonService.lookupCityState(city, state);
    const { payload } = response;
    return payload || null;
  } catch (error) {
    if (__DEV__) {
      console.error("Error looking up city/state:", error);
    }
    if (
      error.status === 404 &&
      error?.response?.data?.message === "No ZIP codes found for city/state"
    ) {
      throw error;
    }
    return null;
  }
}

/**
 * Example usage:
 * const zips = await lookupZipByCityState("Los Angeles", "CA");
 */

/**
 * Looks up city and state for a zip code using PersonService.
 * @param {string} zip
 * @returns {Promise<{city: string, state: string}|null>} Resolves to city/state object or null on error.
 */
export async function lookupCityStateByZip(zip) {
  try {
    const response = await PersonService.lookupZip(zip);
    const { city, state } = response.payload;
    if (city && state) {
      return { city, state };
    }
    return null;
  } catch (error) {
    if (__DEV__) {
      console.error("Error looking up zip:", error);
    }
    if (
      error.status === 404 &&
      error?.response?.data?.message === "ZIP code not found"
    ) {
      throw error;
    }
    return null;
  }
}

/**
 * Example usage:
 * const result = await lookupCityStateByZip("90210");
 * // result: { city: "Beverly Hills", state: "CA" }
 */
